import { Phone, Mail } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { company } from "@/data/content";

export const About = () => (
  <section id="o-nas" className="scroll-mt-24 bg-background" data-testid="about-section">
    <div className="mx-auto max-w-7xl px-5 py-20 lg:px-10 lg:py-28">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <Reveal className="lg:col-span-7">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-accent">O firmě</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
            GOALSTAV – Kvalitní rekonstrukce a fasády v Plzni
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-muted-foreground">
            Jsme stavební firma z Plzně zaměřená na rekonstrukce bytů,
            rodinných domů, zateplení fasád a zednické práce. Každé zakázce
            věnujeme individuální přístup a důraz na kvalitní provedení.
          </p>
          <div className="mt-10 grid max-w-xl grid-cols-1 gap-6 border-t border-border pt-8 sm:grid-cols-2">
            <div>
              <p className="text-lg font-semibold text-foreground">{company.owner}</p>
              <p className="mt-0.5 text-sm text-muted-foreground">{company.ownerRole}</p>
              <p className="mt-3 text-sm text-muted-foreground">IČO {company.ico}</p>
            </div>
            <div className="flex flex-col gap-2.5">
              <a
                href={company.phoneHref}
                data-testid="about-phone"
                className="flex items-center gap-2 text-sm font-semibold text-foreground transition-colors hover:text-accent"
              >
                <Phone className="h-4 w-4 text-accent" /> {company.phone}
              </a>
              <a
                href={company.emailHref}
                data-testid="about-email"
                className="flex items-center gap-2 text-sm font-semibold text-foreground transition-colors hover:text-accent"
              >
                <Mail className="h-4 w-4 text-accent" /> {company.email}
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
